export const eventFields = `
  id
  createdAt
  event
  meta
  updatedAt
  userId
`;

export const insightsEventFieldsOptimization = `
  createdAtEpoch
  event
  userId
`;
